import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
import { heroFacts, mockups } from '../data/content';
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section id="top" className="w-full bg-cream pb-16 pt-12 md:pb-20 md:pt-16" data-id="element-92" data-mp="9luyujz7c3so">
      <div className="mx-auto w-full max-w-content px-5 text-center md:px-8" data-id="element-93" data-mp="4m8kg77n0hia">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease
      }} className="inline-flex items-center gap-2 rounded-full bg-rose-100 px-4 py-2 font-display text-[0.7rem] font-extrabold uppercase tracking-[0.16em] text-rose-600 ring-1 ring-rose-200" data-id="element-94" data-mp="129h6c3bjvskt">
          <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-95" data-mp="nbopn7u9oy51" />
          Solución profesional para salud femenina
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.05,
        ease
      }} className="mx-auto mt-6 max-w-4xl font-display text-[2.35rem] font-extrabold leading-[1.04] tracking-tight text-ink sm:text-5xl md:text-[3.5rem]" data-id="element-96" data-mp="3cz5weevm861x">
          Transforma tu Octubre Rosa en{' '}
          <span className="bg-rose-200 px-1.5 pb-0.5 leading-tight text-plum-900" data-id="element-97" data-mp="39a36uyp2pbm9">
            una experiencia que empodera, conecta y deja huella
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease
      }} className="mx-auto mt-6 max-w-3xl font-display text-xl font-bold leading-snug text-gray-600 md:text-2xl" data-id="element-98" data-mp="30h9djxcskbpe">
          El único megakit 4 en 1 con 50 tarjetas reflexivas, diario de autocuidado, guía de
          dinámicas y 3 bonos profesionales listos para imprimir
        </motion.p>

        <motion.img initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.14,
        ease
      }} src={mockups.kit} alt="Kit completo 4 en 1: tarjetas reflexivas, diario del participante, guía de dinámicas y tarjetas de regalo con pegatinas" className="mx-auto mt-10 w-full max-w-3xl rounded-3xl shadow-lift" width={1024} height={1024} data-id="element-99" data-mp="2lla5untlgdks" />

        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease
      }} className="mx-auto mt-11 max-w-3xl" data-id="element-100" data-mp="dbar95zzdixx">
          <p className="mx-auto max-w-2xl text-lg leading-relaxed text-gray-500" data-id="element-101" data-mp="112g6biy3k776">
            Un sistema completo de empoderamiento, autocuidado y concientización listo para usar en
            consultorios, escuelas, empresas, talleres e instituciones.
          </p>

          <ul className="mt-9 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-sm font-semibold text-gray-500" data-id="element-102" data-mp="3lqugltxj6h7p">
            {heroFacts.map((fact, index) => <li key={fact} className="inline-flex items-center gap-3" data-id="element-103" data-mp="1xavz0ob4wg9d" data-mpi={index}>
                {index > 0 && <span className="h-1 w-1 rounded-full bg-gold-300" aria-hidden="true" data-id="element-104" data-mp="21b63fwja2ym4" />}
                {fact}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}